import React, { useState } from "react";

import { TipoInformacao, Tipos } from "../../data/interfaces";
import logoImg from "../../images/menu/logo.png";
import { Contants } from "../constants";
import {
  Container,
  ContainerLogo,
  Menu,
  ItemMenu,
  SectionMenu,
  LinkMenu,
  LinkSale,
  ItemMenuLogo,
  ImgLogo,
  MenuTogle,
  IconMenu,
  ContainerMenu,
  IconCloseMenu,
  ContainerIconCloseMenu,
  ContainerIconMenu,
  ContainerMidias,
  ContainerMainMenu,
  ImgSale,
  ImgVideo,
  ImgFacebook,
  ImgInstagram,
} from "./styles";

function Nav() {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  function handleShowMenu() {
    setIsOpen(!isOpen);
  }

  function handleMenuClose() {
    setIsOpen(false);
  }

  return (
    <Container>
      <ContainerLogo>
        <ImgLogo src={logoImg} alt="Logo" />
      </ContainerLogo>
      <ContainerMainMenu>
        <ContainerMenu isOpen={isOpen}>
          <MenuTogle>
            <ContainerIconMenu isOpen={isOpen}>
              <IconMenu
                onClick={() => {
                  handleShowMenu();
                }}
              />
            </ContainerIconMenu>

            <ContainerIconCloseMenu isOpen={isOpen}>
              <IconCloseMenu
                onClick={() => {
                  handleShowMenu();
                }}
              />
            </ContainerIconCloseMenu>
          </MenuTogle>
          <Menu isOpen={isOpen}>
            <SectionMenu isOpen={isOpen}>
              <ItemMenuLogo isOpen={isOpen}>
                <LinkMenu to="/">
                  <ImgLogo src={logoImg} alt="Logo" />
                </LinkMenu>
              </ItemMenuLogo>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to="/lojas">Lojas</LinkMenu>
              </ItemMenu>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to="/">Profissional</LinkMenu>
              </ItemMenu>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to="/eventos">Agenda</LinkMenu>
              </ItemMenu>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to={`/informativos/${TipoInformacao.VITAMINAS}`}>
                  Vitaminas
                </LinkMenu>
              </ItemMenu>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to={`/informativos/${TipoInformacao.SUPLEMENTOS}`}>
                  Suplementos
                </LinkMenu>
              </ItemMenu>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to={`/informativos/${TipoInformacao.MAGRO}`}>
                  +Magro
                </LinkMenu>
              </ItemMenu>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to={`/informativos/${TipoInformacao.MASSA}`}>
                  +Massa
                </LinkMenu>
              </ItemMenu>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to={`/informativos/${TipoInformacao.NUTRIENTES}`}>
                  Nutrientes
                </LinkMenu>
              </ItemMenu>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to={`/informativos/${TipoInformacao.WHEY}`}>
                  Whey Protrein
                </LinkMenu>
              </ItemMenu>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to={`/informativos/${TipoInformacao.ANABOLIZANTES}`}>
                  Anabolizantes
                </LinkMenu>
              </ItemMenu>
              <ItemMenu
                onClick={() => {
                  handleMenuClose();
                }}
                isOpen={isOpen}
              >
                <LinkMenu to={`/informativos/${TipoInformacao.INFO}`}>
                  Informação
                </LinkMenu>
              </ItemMenu>
            </SectionMenu>
          </Menu>
        </ContainerMenu>
        <ContainerMidias>
          <a
            href={Contants.LINK_FACEBOOK}
            rel="noreferrer noopener"
            target="_blank"
          >
            <ImgFacebook />
          </a>
          <a
            href={Contants.LINK_INSTAGRAM}
            rel="noreferrer noopener"
            target="_blank"
          >
            <ImgInstagram />
          </a>
          <a
            href={Contants.LINK_YOUTUBE}
            rel="noreferrer noopener"
            target="_blank"
          >
            <ImgVideo />
          </a>
          <LinkSale to={`/promocao/${Tipos.PROMOCAO}`}>
            <ImgSale />
          </LinkSale>
        </ContainerMidias>
      </ContainerMainMenu>
    </Container>
  );
}

export default Nav;
